import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'row',
    'confirmModal',
    'acknowledgementCheckbox',
    'submitButton',
  ]

  static values = {
    url: String,
  }

  connect() {
    this.draggedRow = null
    this.orderChanged = false
    this.saving = false

    if (this.hasConfirmModalTarget && window.$) {
      window.$(this.confirmModalTarget).on('hidden.bs.modal', () => {
        this.resetModalState()
      })
    }
  }

  toggleAcknowledgement() {
    if (!this.hasSubmitButtonTarget) return

    this.submitButtonTarget.disabled = !this.acknowledgementChecked()
  }

  dragstart(event) {
    const row = event.target.closest('tr[data-id]')
    if (!row) return

    this.draggedRow = row
    this.orderChanged = false
    row.classList.add('dragging')

    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData('text/plain', row.dataset.id)
    }
  }

  dragover(event) {
    event.preventDefault()

    const overRow = event.target.closest('tr[data-id]')
    if (!overRow || !this.draggedRow || overRow === this.draggedRow) return

    const bounds = overRow.getBoundingClientRect()
    const isAfter = event.clientY > bounds.top + bounds.height / 2
    const parent = overRow.parentNode

    if (isAfter) {
      parent.insertBefore(this.draggedRow, overRow.nextSibling)
    } else {
      parent.insertBefore(this.draggedRow, overRow)
    }

    this.orderChanged = true
  }

  drop(event) {
    event.preventDefault()
  }

  async dragend() {
    if (this.draggedRow) {
      this.draggedRow.classList.remove('dragging')
      this.draggedRow = null
    }

    if (!this.orderChanged || this.saving) return

    const subprocessorIds = this.rowTargets
      .map((row) => row.dataset.id)
      .filter((id) => id)

    if (subprocessorIds.length === 0) return

    try {
      this.saving = true

      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': this.csrfToken(),
        },
        body: JSON.stringify({ subprocessor_ids: subprocessorIds }),
      })

      if (!response.ok) {
        throw new Error('Reorder request failed')
      }

      window.location.reload()
    } catch {
      // Revert to server-truth if save fails.
      window.location.reload()
    } finally {
      this.saving = false
      this.orderChanged = false
    }
  }

  acknowledgementChecked() {
    return (
      this.hasAcknowledgementCheckboxTarget &&
      this.acknowledgementCheckboxTarget.checked
    )
  }

  resetModalState() {
    if (this.hasAcknowledgementCheckboxTarget) {
      this.acknowledgementCheckboxTarget.checked = false
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
    }
  }

  csrfToken() {
    const element = document.querySelector('meta[name="csrf-token"]')
    return element ? element.content : ''
  }
}
